import React from 'react';
import { ArcCollapse, ArcStack, ArcStatusPoint, ArcText } from '@src/core/ui';
import { ToggleCollapseViewProps } from './types';
import { useSelector } from 'react-redux';
import { OrderStatusColors, OrderStatusNames } from '@src/features/order/entities';
import { selectCollapse } from '@src/features/order/pages/orders-page/redux';

const ToggleCollapseView: React.FC<ToggleCollapseViewProps> = (props) => {
  const { status, children, count = 0 } = props;

  const collapse = useSelector(selectCollapse);

  const isDisabled = count < 1;
  const isOpen = isDisabled ? false : collapse[status];
  


  return (
    <ArcStack direction='column' height='100%' sx={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <ArcStack 
        spacing={1} 
        direction='row' 
        alignItems='center'
        justifyContent='space-between'
        sx={{ cursor: 'pointer', flexShrink: 0 }}>

        <ArcStack 
          spacing={1} 
          direction='row' 
          alignItems='center'>
          <ArcStatusPoint.s bgcolor={OrderStatusColors[status]} />
          <ArcText.h5 
            color={isDisabled ? 'text.secondary' : 'text.primary'}> 
            {OrderStatusNames[status]} ({count})
          </ArcText.h5>
        </ArcStack>
      </ArcStack>

      <ArcCollapse 
        in={isOpen}
        timeout="auto"
        unmountOnExit={false}>
        {children}
      </ArcCollapse>
    </ArcStack>
  );
};

export default ToggleCollapseView;